import Backbone from 'backbone'

const PageImageView = Backbone.View.extend({
    tagName: 'img',
    id: 'page-image-view',
    render() {
        this.el.src = 'data/' + this.model.get('slug') + '/screens/' + this.model.get('image_prefix') + '/item' + this.model.get('index') + '.webp'

        this.$el.on('load', () => this.$el.addClass('visible'))

        return this
    }
})

export default PageImageView

